<template>
  <b-modal
    id="export-estore-orders-modal"
    title="Export Orders"
    hide-footer
    centered
    @show="selectedFilter = 'all'"
  >
    <b-form-group label="Filter:" label-for="export-select">
      <b-form-select
        id="export-select"
        v-model="selectedFilter"
        :options="options"
      >
      </b-form-select>
      <template v-if="selectedFilter === 'date_range'">
        <b-input-group @click="toggleDateRangePicker" class="mt-3">
          <datepicker :config="dateRangeConfig" placeholder="Select Date Range">
          </datepicker>
          <b-input-group-append>
            <i class="icon-calendar mr-1"></i>
            <i
              v-if="startDate && endDate"
              class="icon-clear-calendar"
              @click.stop="clearDateRangePicker"
            ></i>
          </b-input-group-append>
        </b-input-group>
      </template>

      <b-button
        block
        variant="primary"
        class="btn-pill mt-4"
        @click="exportOrders"
        :disabled="loading || isDisabledButton"
      >
        Export
      </b-button>
    </b-form-group>
  </b-modal>
</template>

<script>
import Datepicker from "vue-bulma-datepicker";
import { mapState } from "vuex";

export default {
  props: ["parameters"],
  data() {
    return {
      options: [
        { text: "All", value: "all" },
        { text: "Date Range", value: "date_range" },
      ],
      selectedFilter: "all",
      dateRangePicker: null,
      startDate: "",
      endDate: "",
    };
  },
  computed: {
    ...mapState("estoreOrders", ["loading", "errors"]),
    ...mapState("analytics", ["isSegmentAnalyticsReady"]),
    dateRangeConfig() {
      const _this = this;

      return {
        altInput: true,
        altFormat: "M j, Y",
        dateFormat: "Y-m-d",
        static: true,
        mode: "range",
        maxDate: "today",
        onChange: function (value) {
          if (value.length == 2) {
            _this.startDate = _this.$moment(value[0]).format("YYYY-MM-DD");
            _this.endDate = _this.$moment(value[1]).format("YYYY-MM-DD");
          }
        },
        onReady: function (_, __, instance) {
          _this.dateRangePicker = instance;
        },
      };
    },
    isDisabledButton() {
      if (
        this.selectedFilter === "date_range" &&
        (!this.startDate || !this.endDate)
      )
        return true;

      return false;
    },
  },
  methods: {
    toggleDateRangePicker() {
      if (this.dateRangePicker) this.dateRangePicker.open();
    },
    clearDateRangePicker() {
      if (this.dateRangePicker) this.dateRangePicker.clear();

      this.startDate = "";
      this.endDate = "";
    },
    async exportOrders() {
      let parameters = this.parameters;

      if (this.selectedFilter === "date_range") {
        parameters = {
          ...parameters,
          start_date: this.startDate,
          end_date: this.endDate,
        };
      }

      await this.$store.dispatch("estoreOrders/exportHistory", parameters);

      if (
        !this.errors &&
        this.isSegmentAnalyticsReady
      ) {
        window.analytics.track("Export E-Store Orders", parameters);
      }

      this.$root.$emit("bv::hide::modal", "export-estore-orders-modal");
    },
  },
  components: { Datepicker },
  watch: {
    selectedFilter(selected) {
      if (selected === "date_range") this.clearDateRangePicker();
    },
  },
};
</script>

<style lang="scss">
#export-estore-orders-modal {
  .input-group {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 #e3e3e3;
    .flatpickr-wrapper {
      flex: 1;
      & > .form-control {
        background: transparent;
        border: 0;
        border-radius: 0;
        box-shadow: none;
        color: #2a2a2a;
        font-family: MainFontBold, sans-serif;
        font-size: 14px;
      }
    }
    .input-group-prepend,
    .input-group-append {
      padding: 0 10px 0 0;
      display: flex;
      align-items: center;
      .input-group {
        box-shadow: none;
      }
    }
  }
  [class^="icon-"] {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: text-bottom;
    cursor: pointer;
    &.icon-calendar {
      background: transparent url("../../assets/images/icons/calendar.svg")
        no-repeat center / 20px;
    }
    &.icon-clear-calendar {
      background: transparent
        url("../../assets/images/icons/clear-calendar.svg") no-repeat center /
        20px;
    }
  }
}
</style>